////////LIBRARY/////////
import { find, isEmpty, isNull, isUndefined, map, replace } from 'lodash'
import moment from 'moment'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { useRouteMatch } from 'react-router'
import { useHistory } from 'react-router-dom'
import Timeline from 'react-timelines'
import { bindActionCreators } from 'redux'
import styled from 'styled-components'
///////COMPONENTS///////
import 'react-timelines/lib/css/style.css'
import Button from '../../components/Ui/Buttons'
import { articleLifeStatusPicsConfig } from '../../constants/AssetsPicturesConfigList'
import userPrivileges from '../../constants/PrivilegesList'
import { uriList } from '../../routings/settings/RouteList'
import { articleLifeManagerActionCreators } from '../../store/actions'
import {
	InputWrapper,
	OptionCustom,
	PageTitle,
	PageWrapperGrids,
	PageWrapperLinks,
	SelectInputCustom,
	SelectInputWrapper,
} from '../../theme/GlobalCss'
import ModalsContainer from './Components/ModalsContainer/ModalsContainer'
/////////ASSETS/////////
import TimelineArrow from '../../assets/icones/global/back-arrow.svg'

/////////STYLED/////////
const ArticleLifeManagerWrapper = styled.div`
	position: relative;
`
const PageWrapperGridsCustom = styled(PageWrapperGrids)`
	grid-template-columns: 1096px 33%;
`
const TimelineHandler = styled.div`
	position: relative;
	& button {
		border: 0;
		box-sizing: border-box;
	}
	& .rt {
		width: ${(props) => (props.widthHelper > 0 ? `${props.widthHelper * props.zoom}px` : `auto`)};
	}
	& .rt-layout {
		margin-top: 60px;
	}
	& .rt-controls {
		position: fixed;
		z-index: 100;
	}
	& .rt-layout__side {
		display: none;
	}
	& .rt-layout__main {
		/*min-width: ${(props) => (props.widthHelper > 0 ? `${props.widthHelper}px` : `auto`)};*/
		font-size: ${(props) => props.theme.font.fs};
		width: auto !important;
	}
	& .rt-layout__timeline {
		overflow-x: unset;
	}
	& .rt-marker__content {
		font-size: ${(props) => props.theme.font.fs};
		& strong {
			font-weight: normal;
		}
		& span {
			font-weight: normal;
			line-height: 18px;
		}
	}
	/* Grid display */
	& .rt-timeline {
		border: 1px solid ${(props) => props.theme.colors.TabNav.border};
	}
	& .rt-grid__cell:nth-child(odd) {
		background-color: ${(props) => props.theme.colors.TabNav.border};
	}
	& .rt-grid__cell {
		border-left: 1px solid ${(props) => props.theme.colors.TabNav.border};
	}
	& .rt-track__elements {
		border-bottom: none;
	}
	& .rt-timebar__cell:first-child {
		border-left: none;
	}
	/* Tooltip */
	& .rt-element__tooltip strong {
		margin-right: 3px;
	}
	/* Today marker */
	& .rt-marker--now {
		color: ${(props) => props.theme.colors.primary};
		border-color: ${(props) => props.theme.colors.primary};
		visibility: ${(props) => (props.todayBarPos === 'visible' ? 'visible' : 'hidden')};
	}
	& .rt-marker--now .rt-marker--label {
		line-height: 16px;
	}
	& .rt-marker--now .rt-marker__label {
		bottom: 0px;
		height: 16px;
		font-size: ${(props) => props.theme.font.fs};
	}
	& .rt-marker--now .rt-marker__label::before {
		display: none;
	}
	& .rt-marker--now .rt-marker__label .rt-marker__content > div > * {
		display: inline-block;
		font-size: ${(props) => props.theme.font.fxs};
		line-height: 16px;
		font-weight: normal;
		margin: 0px 2px;
	}
	/* Pointer marker */
	& .rt-marker--pointer .rt-marker__content {
		& > div > div {
			position: relative;
		}
		& strong {
			visibility: hidden;
			width: 0px;
			overflow: hidden;
			display: inline-block;
		}
		& span {
			visibility: visible;
		}
	}
	/* Elements of timeline */
	& .rt-element {
		height: 32px;
		line-height: 32px;
		z-index: 50;
		min-width: 1px;

		& .rt-element__content {
			font-weight: normal;
			text-overflow: '';
			padding: 0px;
		}
	}
`
const TimelineHeader = styled.div`
	height: max-content;
	width: 40%;
	display: grid;
	grid-template-column: 1fr;
	grid-template-rows: 30px;
`
const TimelineState = styled.div`
	display: flex;
	align-items: center;
	& > div:nth-child(1) {
		font-weight: 900;
		margin-right: 9px;
	}
	& > div:nth-child(3) {
		margin-left: 11px;
		color: ${(props) => props.theme.colors.blackArticleLife};
	}
`
const TimelineStateKey = styled.div``

const TimelineStateStatus = styled.div``

const TimelineActions = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	position: absolute;
	right: 0px;
	padding: 10px;
	z-index: 5;
`
const TimelineWrapper = styled.div`
	position: relative;
	width: ${(props) => (props.widthHelper > 0 ? `${props.widthHelper}px` : `auto`)};
	overflow-x: scroll;
`
const TimelinePrevHandler = styled.div`
	position: absolute;
	left: 0px;
	bottom: 0px;
	height: 90px;
	width: 90px;
	top: 50%;
	transform: translateY(-50%);
	z-index: 2;
	visibility: ${(props) => (props.hovered ? 'visible' : 'hidden')};
`
const TimelineNextHandler = styled.div`
	position: absolute;
	left: calc(${(props) => props.widthHelper}px - 90px);
	bottom: 0px;
	height: 90px;
	width: 90px;
	top: 50%;
	transform: translateY(-50%);
	z-index: 2;
	visibility: ${(props) => (props.hovered ? 'visible' : 'hidden')};
`
const TimelineArrowWrapper = styled.div`
	width: 75px;
	height: 75px;
	border-radius: 75px;
	background-color: rgba(77, 79, 92, 0.5);
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translateY(-50%) translateX(-50%);
	cursor: pointer;
	&:hover {
		background-color: ${(props) => props.theme.colors.primary};
	}
`
const TimelineArrowContentWrapper = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translateX(-50%) translateY(-50%);
	text-align: center;
	& > span {
		color: ${(props) => props.theme.colors.white};
		font-weight: bold;
		font-size: ${(props) => props.theme.font.fs};
	}
	display: flex;
	flex-direction: column;
	align-items: center;
`
const TimelineArrowPrev = styled.div`
	background-image: url(${TimelineArrow});
	width: 16px;
	height: 18px;
	background-size: 16px 18px;
	background-position: center;
	display: inline-block;
`
const TimelineArrowNext = styled.div`
	background-image: url(${TimelineArrow});
	width: 16px;
	height: 18px;
	background-size: 16px 18px;
	background-position: center;
	display: inline-block;
	transform: scale(-1);
`
const TimelineBarToday = styled.div`
	width: 145px;
	text-align: center;
	background-color: ${(props) => props.theme.colors.primary};
	color: ${(props) => props.theme.colors.white};
	cursor: pointer;
	position: fixed;
	transform: ${(props) => `translateY(calc(${props.heightHelper + 60}px - 16px))`}
		${(props) => (props.todayBarPos === 'right' ? `translateX(calc(${props.widthTimeline}px - 165px))` : ``)};
	font-size: 13px;
	line-height: 16px;
	z-index: 5;
	display: ${(props) => (props.todayBarPos === 'visible' ? 'none' : 'initial')};
	padding: 0px 10px;
`
const TimelineLegendWrapper = styled.div`
	width: ${(props) => `${props.widthHelper}px`};
	display: flex;
	flex-direction: row;
	margin-top: 15px;
	font-size: ${(props) => props.theme.font.fs};
`
const TimelineLegendPart = styled.div`
	margin-right: 30px;
	display: flex;
	align-items: center;
`
const TimelineLegend = styled.span`
	margin-left: 10px;
`

const TimelineLegendColorCode = styled.div`
	border-radius: 20px;
	width: 20px;
	height: 20px;
	background-color: ${(props) => `${props.colorCode}`};
`
/////////STYLED/////////

const ArticleLifeManager = () => {
	// [63] hooks
	const [unactiveModal, setUnactiveModal] = useState(false)
	const [deleteModal, setDeleteModal] = useState(false)
	const [deleteStopDepositModal, setDeleteStopDepositModal] = useState(false)
	const [activeModal, setActiveModal] = useState(false)
	const [modifyAddStartWithDepositActionModal, setModifyAddStartWithDepositActionModal] = useState(false)
	const [deleteAddStartWithDepositModal, setDeleteAddStartWithDepositModal] = useState(false)
	const [addStopDepositModal, setAddStopDepositModal] = useState(false)
	const [deleteScheduledActivateModal, setDeleteScheduledActivateModal] = useState(false)
	const [addStartWithDepositActionModal, setAddStartWithDepositActionModal] = useState(false)
	const [modifyScheduledActivateActionModal, setModifyScheduledActivateActionModal] = useState(false)
	const [scheduledActivateActionModal, setScheduledActivateActionModal] = useState(false)
	const [modifyStopDepositModal, setModifyStopDepositModal] = useState(false)

	// [88] hooks
	const [scheduleDeactivateActionModal, setScheduleDeactivateActionModal] = useState(false)
	const [cancelDeactivateActionModal, setCancelDeactivateActionModal] = useState(false)
	const [editDeactivateActionModal, setEditDeactivateActionModal] = useState(false)
	const [deleteDeactivationActionModal, setDeleteDeactivationActionModal] = useState(false)
	const [deleteStopWithRestockActionModal, setDeleteStopWithRestockActionModal] = useState(false)
	const [addStopWithRestockActionModal, setAddStopWithRestockActionModal] = useState(false)
	const [editStopWithRestockActionModal, setEditStopWithRestockActionModal] = useState(false)

	const { translations, articleLifeManager, articleLifeManagerHeaderactionsOnItem, articleLifeIsUpdate, userRolePrivileges } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			user: state.user,
			articleLifeManager: state.articleLifeManager,
			articleLifeManagerHeaderactionsOnItem: state.articleLifeManager.header.actionsOnItem,
			articleLifeIsUpdate: state.articleLifeManager.isUpdate,
			userRolePrivileges: state.user.identity.rolePrivileges,
		}),
		shallowEqual
	)

	let history = useHistory()
	const match = useRouteMatch()

	const actionsArticleLifeManager = bindActionCreators(articleLifeManagerActionCreators, useDispatch())

	const [selectTarget, setSelectTarget] = useState(false) // when is true we change placeholder color of select element
	const selectActionRef = useRef() // Ref of action <select>
	const [articleLifeStatusPict, setArticleLifeStatusPict] = useState()

	// Timeline parameters and functions
	const [zoom, setZoom] = useState(1)

	const timelineRef = useRef()
	const timelineWrapperRef = useRef()

	const [widthTimeline, setWidthTimeline] = useState(0)
	const [heightTimeline, setHeightTimeline] = useState(0)

	const [currentTimelineYear, setCurrentTimelineYear] = useState(moment().format('YYYY'))
	const [currentTimelineData, setCurrentTimelineData] = useState([])
	const [currentTimelineHeader, setCurrentTimelineHeader] = useState([])

	const [timelineStartYear, setTimelineStartYear] = useState(moment().startOf('year').subtract(1, 'years').toDate())
	const [timelineEndYear, setTimelineEndYear] = useState(moment().endOf('year').add(1, 'years').toDate())

	// Markers
	const [todayBar, setTodayBar] = useState('')
	const [todayBarPos, setTodayBarPos] = useState('visible')
	const [pointerText, setPointerText] = useState('')
	const months_searched = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
	const months_translated = [
		'page__itemRef__timeline_month_january',
		'page__itemRef__timeline_month_february',
		'page__itemRef__timeline_month_march',
		'page__itemRef__timeline_month_april',
		'page__itemRef__timeline_month_may',
		'page__itemRef__timeline_month_june',
		'page__itemRef__timeline_month_july',
		'page__itemRef__timeline_month_august',
		'page__itemRef__timeline_month_september',
		'page__itemRef__timeline_month_october',
		'page__itemRef__timeline_month_november',
		'page__itemRef__timeline_month_december',
	]

	const [timelineHovered, setTimelineHovered] = useState()

	const getPointerText = (_e) => {
		const a = timelineWrapperRef.current.querySelector('.rt-marker--pointer .rt-marker__content > div > div > strong')
		if (!isNull(a)) {
			setPointerText(a.textContent)
		}
	}

	const goTodayMarker = () => {
		// First, we check if today date is on n-1 to n+1 years
		const todayYear = parseInt(moment().format('YYYY'))
		if (todayYear < parseInt(moment(timelineStartYear).format('YYYY')) || todayYear > parseInt(moment(timelineEndYear).format('YYYY'))) {
			handleDataTimeline(todayYear)
		} else {
			if (todayBarPos === 'left') {
				//timelineWrapperRef.current.scrollLeft = todayBar.offsetLeft
				timelineWrapperRef.current.scrollLeft = todayBar.offsetLeft - widthTimeline / 2
			}
			if (todayBarPos === 'right') {
				timelineWrapperRef.current.scrollLeft = todayBar.offsetLeft - widthTimeline + widthTimeline / 2
				//timelineWrapperRef.current.scrollLeft = (todayBar.offsetLeft / timelineWrapperRef.current.scrollWidth) * timelineWrapperRef.current.scrollWidth
			}
		}
	}

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleRedirect = () => {
		history.push(`${uriList.distributionItems}${uriList.distributionGroupRepo}`)
	}

	const handleZoomIn = () => {
		setZoom(Math.min(zoom + 0.5, 2.5))
	}

	const handleZoomOut = () => {
		setZoom(Math.max(zoom - 0.5, 1))
	}

	const handleDataTimeline = (year) => {
		actionsArticleLifeManager.getTimeline(match.params.id, year)
		// Also resetting zoom
		setZoom(1)
	}

	const handleScrollTimeline = (e) => {
		// If scroll exceeds offset of today bar, we hide it or place it sticky ?
		if (e.target.scrollLeft > todayBar.offsetLeft + todayBar.clientWidth) {
			setTodayBarPos('left')
		} else if (e.target.scrollLeft < todayBar.offsetLeft - widthTimeline) {
			setTodayBarPos('right')
		} else {
			setTodayBarPos('visible')
		}
	}

	// Actions functions
	const handleChoiceTarget = () => {
		setSelectTarget(true)
	}

	const handleSwitchActions = (query, reset = false) => {
		if (reset) {
			setSelectTarget(false)
			selectActionRef.current.value = ''
			return null
		}
		handleChoiceTarget()
		switch (query.target.value) {
			// [63] Actions
			case 'Unactive':
				setUnactiveModal(true)
				break
			case 'Deleted':
				setDeleteModal(true)
				break
			case 'AddStopDeposit':
				setAddStopDepositModal(true)
				break
			case 'ModifyStopDeposit':
				setModifyStopDepositModal(true)
				break
			case 'DeleteStopDeposit':
				setDeleteStopDepositModal(true)
				break
			case 'AddStartWithDepositAction':
				setAddStartWithDepositActionModal(true)
				break
			case 'ModifyAddStartWithDepositAction':
				setModifyAddStartWithDepositActionModal(true)
				break
			case 'DeleteAddStartWithDepositAction':
				setDeleteAddStartWithDepositModal(true)
				break
			case 'Active':
				setActiveModal(true)
				break
			case 'ScheduledActivateAction':
				setScheduledActivateActionModal(true)
				break
			case 'ModifyScheduledActivateAction':
				setModifyScheduledActivateActionModal(true)
				break
			case 'DeleteScheduledActivateAction':
				setDeleteScheduledActivateModal(true)
				break
			// [88] Actions
			case 'scheduleDeactivateAction':
				setScheduleDeactivateActionModal(true)
				break
			case 'cancelDeactivationAction':
				setCancelDeactivateActionModal(true)
				break
			case 'editDeactivationAction':
				setEditDeactivateActionModal(true)
				break
			case 'deleteDeactivationAction':
				setDeleteDeactivationActionModal(true)
				break
			case 'deleteStopWithRestockAction':
				setDeleteStopWithRestockActionModal(true)
				break
			case 'addStopWithRestockAction':
				setAddStopWithRestockActionModal(true)
				break
			case 'editStopWithRestockAction':
				setEditStopWithRestockActionModal(true)
				break
			default:
				break
		}
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	// On loading page
	useEffect(() => {
		if (isEmpty(translations)) return
		const idArticle = match.params.id
		actionsArticleLifeManager.getHeaderAndAction(idArticle)

		return function cleanUp() {
			actionsArticleLifeManager.resetDataArticleLife()
		}
	}, [translations])

	useEffect(() => {
		// First call to get timeline data ?
		if (!isEmpty(translations)) {
			actionsArticleLifeManager.getTimeline(match.params.id, currentTimelineYear)
		}
	}, [translations])

	// Updating timeline data
	useEffect(() => {
		if (isEmpty(translations)) return
		if (!isEmpty(articleLifeManager.timelineData)) {
			let d = [articleLifeManager.timelineData.data]
			d[0].elements = map(d[0].elements, (elem) => {
				elem.title = translations[elem.translationKey]
				elem.start = moment(elem.dateStart).toDate()
				elem.end = moment(elem.dateEnd).toDate()
				elem.style = { backgroundColor: elem.colorCode }
				return elem
			})
			d[0].tracks = map(d[0].tracks, (trk) => {
				trk.elements = map(trk.elements, (el) => {
					el.title = translations[el.translationKey]
					el.start = moment(el.dateStart).toDate()
					el.end = moment(el.dateEnd).toDate()
					el.style = { backgroundColor: el.colorCode }
					return el
				})
				return trk
			})
			// Add artificial margin => subtracks that are empty on elements
			d[0].tracks.push({ elements: [] })
			d[0].tracks.push({ elements: [] })

			d[0].isOpen = true
			setCurrentTimelineData(d)

			let f = [articleLifeManager.timelineData.header]
			let t = []
			f[0].trimesters.cells = map(f[0].trimesters.cells, (elem) => {
				elem.title = `${translations[elem.title]} ${elem.year}`
				elem.start = moment(elem.start).toDate()
				elem.end = moment(elem.end).toDate()
				return elem
			})

			f[0].months.cells = map(f[0].months.cells, (elem) => {
				elem.title = `${translations[elem.title]}`
				elem.start = moment(elem.start).toDate()
				elem.end = moment(elem.end).toDate()
				return elem
			})

			t[0] = { cells: f[0].trimesters.cells }
			t[1] = { cells: f[0].months.cells, useAsGrid: true }

			setCurrentTimelineHeader(t)

			// Also changing years
			setTimelineStartYear(moment(articleLifeManager.timelineData.header.middleYear, 'YYYY').startOf('year').subtract(1, 'years').toDate())
			setTimelineEndYear(moment(articleLifeManager.timelineData.header.middleYear, 'YYYY').endOf('year').add(1, 'years').toDate())

			// Adding legend by back call
			actionsArticleLifeManager.getTimelinePhases(match.params.id)
		}
	}, [articleLifeManager.timelineData, translations])

	// Updating timeline legend
	useEffect(() => {
		if (!isEmpty(articleLifeManager.timelineLegend)) return
	}, [articleLifeManager.timelineLegend, translations])

	useEffect(() => {
		if (timelineRef.current?.state.timelineViewportWidth > 0) {
			setWidthTimeline(timelineRef.current.state.time.timelineWidth)
		}
	}, [timelineRef.current?.state.timelineViewportWidth])

	useEffect(() => {
		if (!isNull(timelineWrapperRef?.current) && !isUndefined(timelineWrapperRef?.current) && !isEmpty(currentTimelineData)) {
			// Getting real height of timeline
			const layout = timelineWrapperRef.current.querySelector('.rt-layout')
			setHeightTimeline(layout.clientHeight)

			// Replace english text
			const todayMarker = timelineWrapperRef.current.querySelector('.rt-marker--now .rt-marker__content > div > div:first-child')
			todayMarker.textContent = translations['page__itemRef__timeline_today']

			const todayMarkerDate = timelineWrapperRef.current.querySelector('.rt-marker--now .rt-marker__content > div > strong')
			if (todayMarkerDate.textContent.length > 0) {
				const arrParsed = todayMarkerDate.textContent.split(' ')
				map(months_searched, (element, id) => {
					if (todayMarkerDate.textContent.includes(element)) {
						todayMarkerDate.textContent = replace(todayMarkerDate.textContent, arrParsed[1], translations[months_translated[id]])
					}
				})
			}

			// Getting today marker
			setTodayBar(timelineWrapperRef.current.querySelector('.rt-marker--now'))
			// And adding move event to timeline, so we can translate its markers
			timelineWrapperRef.current.addEventListener('mousemove', (e) => getPointerText(e))

			const lstTooltips = timelineWrapperRef.current.querySelectorAll('.rt-element__tooltip')

			// Translating content
			if (!isEmpty(lstTooltips)) {
				map(lstTooltips, (elem, _id) => {
					const startTag = document.createElement('strong')

					const startDate = elem.querySelector('div > div+div')
					if (startDate.textContent.length > 0) {
						const arrParsed = startDate.textContent.split(' ')
						map(months_searched, (element, id) => {
							if (startDate.textContent.includes(element)) {
								startDate.textContent = `${arrParsed[1]} ${translations[months_translated[id]]}`
							}
						})
					}
					startDate.prepend(startTag)
					startDate.querySelector('strong').textContent = translations['tooltip__admin__itemManagement__timeLine__graph_start']

					const endTag = document.createElement('strong')
					const endDate = elem.querySelector('div > div+div+div')
					if (endDate.textContent.length > 0) {
						const arrParsed = endDate.textContent.split(' ')
						map(months_searched, (element, id) => {
							if (endDate.textContent.includes(element)) {
								endDate.textContent = `${arrParsed[1]} ${translations[months_translated[id]]}`
							}
						})
					}
					endDate.prepend(endTag)
					endDate.querySelector('strong').textContent = translations['tooltip__admin__itemManagement__timeLine__graph_end']
				})
			}
		}
	}, [timelineWrapperRef?.current, translations, currentTimelineData])

	useEffect(() => {
		if (!isUndefined(todayBar) && !isNull(timelineRef?.current)) {
			if (todayBar.offsetLeft > timelineRef?.current?.state?.timelineViewportWidth) {
				setTodayBarPos('right')
				// timelineWrapper.scrollLeft should not be defined, because at this state, we got no zoom, so no scrollbar.
			} else if (todayBar.offsetLeft < (!isUndefined(timelineWrapperRef.scrollLeft) ? timelineWrapperRef.scrollLeft : 0)) {
				setTodayBarPos('left')
			} else {
				setTodayBarPos('visible')
			}
		}
	}, [todayBar, widthTimeline, timelineRef, zoom, currentTimelineData])

	// if actions success we have to call data for refresh the time line
	useEffect(() => {
		if (articleLifeIsUpdate) {
			handleDataTimeline(moment(currentTimelineYear).format('YYYY'))
			const idArticle = match.params.id
			actionsArticleLifeManager.getHeaderAndAction(idArticle)
		}
	}, [articleLifeIsUpdate])

	// When pointer value has changed, we translate it
	useEffect(() => {
		if (pointerText.length > 0) {
			// Date is displayed like this : 1 Jan
			const arrParsed = pointerText.split(' ')

			map(months_searched, (element, id) => {
				if (pointerText.includes(element)) {
					let a = timelineWrapperRef.current.querySelector('.rt-marker--pointer .rt-marker__content > div > div > span')
					// If span tag is not initialized, we create it
					if (isNull(a)) {
						a = timelineWrapperRef.current.querySelector('.rt-marker--pointer .rt-marker__content > div > div')
						a.appendChild(document.createElement('span'))
						a = a.querySelector('span')
					}
					// And place text in it's <span>
					a.textContent = replace(pointerText, arrParsed[1], translations[months_translated[id]])
				}
			})
		}
	}, [pointerText])

	useEffect(() => {
		if (!isUndefined(articleLifeManager.header.itemStatus)) {
			const f = find(articleLifeStatusPicsConfig, { subFlow: articleLifeManager.header.itemStatus.subFlow })
			!isUndefined(f) && setArticleLifeStatusPict(f.picture)
		}
	}, [articleLifeManager.header])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<Fragment>
			{/*MANAGE ALL MODALS*/}
			<ModalsContainer
				// [63] Modals
				// [63]_b): DELETE ITEM
				delete={{ show: deleteModal, close: () => setDeleteModal(false), item: articleLifeManager }}
				// [63]_a): INSTANT DESACTIVE
				unactive={{ show: unactiveModal, close: () => setUnactiveModal(false), item: articleLifeManager }}
				// [63]_s): DELETE STOP DEPOSIT
				deleteStopDeposit={{
					show: deleteStopDepositModal,
					close: () => setDeleteStopDepositModal(false),
					item: articleLifeManager,
					currentDateDeleteStopWithDeposit: articleLifeManagerHeaderactionsOnItem?.find((elem) => elem.query === 'DeleteStopDeposit'),
				}}
				// [63]_g): MODIFY ADD START DEPOSIT
				modifyAddStartWithDepositAction={{
					show: modifyAddStartWithDepositActionModal,
					close: () => setModifyAddStartWithDepositActionModal(false),
					item: articleLifeManagerHeaderactionsOnItem?.find((elem) => elem.query === 'ModifyAddStartWithDepositAction'),
				}}
				//[63]_i): ACTIVATE ITEM
				active={{ show: activeModal, close: () => setActiveModal(false), item: articleLifeManager }}
				// [63]_h): DELETE ADD START DEPOSIT
				deleteAddStartWithDeposit={{
					show: deleteAddStartWithDepositModal,
					close: () => setDeleteAddStartWithDepositModal(false),
					item: articleLifeManager,
					currentDateAddStartWithDeposit: articleLifeManagerHeaderactionsOnItem?.find(
						(elem) => elem.query === 'DeleteAddStartWithDepositAction'
					),
				}}
				// [63]_c): ADD STOP DEPOSIT
				addStopDeposit={{
					show: addStopDepositModal,
					close: () => setAddStopDepositModal(false),
					item: articleLifeManagerHeaderactionsOnItem?.find((elem) => elem.query === 'AddStopDeposit'),
				}}
				// [63]_d): MODIFY STOP DEPOSIT
				modifyStopDeposit={{
					show: modifyStopDepositModal,
					close: () => setModifyStopDepositModal(false),
					item: articleLifeManagerHeaderactionsOnItem?.find((elem) => elem.query === 'ModifyStopDeposit'),
				}}
				// [63]_l): DELETE SCHEDULED ACTIVATION ITEM
				deleteScheduledActivate={{
					show: deleteScheduledActivateModal,
					close: () => setDeleteScheduledActivateModal(false),
					item: articleLifeManager,
					currentDateScheduled: articleLifeManagerHeaderactionsOnItem?.find((elem) => elem.query === 'DeleteScheduledActivateAction'),
				}}
				// [63]_f): ADD START DEPOSIT
				addStartWithDepositAction={{
					show: addStartWithDepositActionModal,
					close: () => setAddStartWithDepositActionModal(false),
					item: articleLifeManagerHeaderactionsOnItem?.find((elem) => elem.query === 'AddStartWithDepositAction'),
				}}
				//[63]_j): SCHEDULED ACTIVATION ITEM
				scheduledActivateAction={{
					show: scheduledActivateActionModal,
					close: () => setScheduledActivateActionModal(false),
					item: articleLifeManagerHeaderactionsOnItem?.find((elem) => elem.query === 'ScheduledActivateAction'),
				}}
				//[63]_k): MODIFY SCHEDULED ACTIVATION ITEM
				modifyScheduledActivateAction={{
					show: modifyScheduledActivateActionModal,
					close: () => setModifyScheduledActivateActionModal(false),
					item: articleLifeManagerHeaderactionsOnItem?.find((elem) => elem.query === 'ModifyScheduledActivateAction'),
				}}
				// [88] Modals
				// [88]_a): LAUNCH PROGRESSIVE DESACTIVATION
				scheduleDeactivateAction={{
					show: scheduleDeactivateActionModal,
					close: () => setScheduleDeactivateActionModal(false),
					item: articleLifeManagerHeaderactionsOnItem?.find((elem) => elem.query === 'scheduleDeactivateAction'),
					currentState: articleLifeManager,
				}}
				// [88]_d): CANCEL PROGRESSIVE DESACTIVATION
				cancelDeactivationAction={{
					show: cancelDeactivateActionModal,
					close: () => setCancelDeactivateActionModal(false),
					current: articleLifeManagerHeaderactionsOnItem?.find((elem) => elem.query === 'cancelDeactivationAction'),
					item: articleLifeManager,
				}}
				//[88]_b): MODIFY PROGRESSIVE DESACTIVATION
				editDeactivationAction={{
					show: editDeactivateActionModal,
					close: () => setEditDeactivateActionModal(false),
					item: articleLifeManagerHeaderactionsOnItem?.find((elem) => elem.query === 'editDeactivationAction'),
					currentState: articleLifeManager,
				}}
				//[88]_c): DELETE PROGRESSIVE DESACTIVATION
				deleteDeactivationAction={{
					show: deleteDeactivationActionModal,
					close: () => setDeleteDeactivationActionModal(false),
					current: articleLifeManagerHeaderactionsOnItem?.find((elem) => elem.query === 'deleteDeactivationAction'),
					item: articleLifeManager,
				}}
				// [88]_g: DELETE DATE STOP RESTOCK
				deleteStopWithRestockAction={{
					show: deleteStopWithRestockActionModal,
					close: () => setDeleteStopWithRestockActionModal(false),
					current: articleLifeManagerHeaderactionsOnItem?.find((elem) => elem.query === 'deleteStopWithRestockAction'),
					item: articleLifeManager,
				}}
				//[88]_e): ADD DATE STOP RESTOCK
				addStopWithRestockAction={{
					show: addStopWithRestockActionModal,
					close: () => setAddStopWithRestockActionModal(false),
					item: articleLifeManagerHeaderactionsOnItem?.find((elem) => elem.query === 'addStopWithRestockAction'),
				}}
				//[88]_f: MODIFY DATE STOP RESTOCK
				editStopWithRestockAction={{
					show: editStopWithRestockActionModal,
					close: () => setEditStopWithRestockActionModal(false),
					item: articleLifeManagerHeaderactionsOnItem?.find((elem) => elem.query === 'editStopWithRestockAction'),
				}}
			/>

			<ArticleLifeManagerWrapper>
				<PageWrapperLinks>
					<Button goBack weight="bold" actionHandler={() => handleRedirect()} text={translations['common__text__previousPage']} />
				</PageWrapperLinks>
				<PageTitle>{`${translations['page__itemRef__timeline_title']} ${articleLifeManager.header.itemRefLabel}`}</PageTitle>
				<TimelineHeader>
					<TimelineState>
						<TimelineStateKey>{translations['page__itemRef__timeline_status']} :</TimelineStateKey>
						{!isUndefined(articleLifeStatusPict) && <img src={articleLifeStatusPict} />}
						<TimelineStateStatus>{translations[articleLifeManager.header.itemStatus?.translationKey]}</TimelineStateStatus>
					</TimelineState>
				</TimelineHeader>
				<PageWrapperGridsCustom grids={2}>
					<TimelineHandler widthHelper={widthTimeline} zoom={zoom} todayBarPos={todayBarPos}>
						<TimelineActions>
							{!isUndefined(find(userRolePrivileges.privileges, (elem) => elem.label === userPrivileges.action[0])) && (
								<InputWrapper>
									<SelectInputWrapper blueColor={true}>
										<SelectInputCustom
											width="300"
											defaultValues=""
											selectTarget={selectTarget}
											onChange={handleSwitchActions}
											ref={selectActionRef}
											onClick={(e) => handleSwitchActions(e, true)}
										>
											<OptionCustom value="" hidden>
												{translations['page__itemRef__timeline_action_placeholder']}
											</OptionCustom>
											{map(articleLifeManagerHeaderactionsOnItem, (elem, id) => {
												return (
													<OptionCustom key={id} value={elem.query} target={true}>
														{translations[elem.translationKey]}
													</OptionCustom>
												)
											})}
										</SelectInputCustom>
									</SelectInputWrapper>
								</InputWrapper>
							)}
						</TimelineActions>
						{!isEmpty(currentTimelineData) &&
							!isEmpty(currentTimelineHeader) &&
							!isEmpty(articleLifeManager.timelineLegend) &&
							translations && (
								<Fragment>
									<TimelinePrevHandler
										className={'rt-timeline-handler'}
										heightHelper={heightTimeline}
										hovered={timelineHovered}
										onMouseEnter={() => setTimelineHovered(true)}
									>
										<TimelineArrowWrapper onClick={() => handleDataTimeline(moment(timelineStartYear).format('YYYY'))}>
											<TimelineArrowContentWrapper>
												<TimelineArrowPrev />
												<span>{moment(timelineStartYear).format('YYYY')}</span>
											</TimelineArrowContentWrapper>
										</TimelineArrowWrapper>
									</TimelinePrevHandler>
									<TimelineWrapper
										ref={timelineWrapperRef}
										onScroll={(e) => handleScrollTimeline(e)}
										widthHelper={widthTimeline}
										onMouseLeave={() => setTimelineHovered(false)}
										onMouseOver={() => setTimelineHovered(true)}
									>
										<TimelineBarToday
											todayBarPos={todayBarPos}
											heightHelper={heightTimeline}
											widthTimeline={widthTimeline}
											onClick={() => goTodayMarker()}
										>
											{`${translations['page__itemRef__timeline_today']} ${moment().format('DD/MM/YYYY')}`}
										</TimelineBarToday>
										<Timeline
											ref={timelineRef}
											scale={{
												start: timelineStartYear,
												end: timelineEndYear,
												zoom,
												zoomMin: 1,
												zoomMax: 2.5,
											}}
											isOpen={true}
											zoomIn={() => handleZoomIn()}
											zoomOut={() => handleZoomOut()}
											timebar={currentTimelineHeader}
											tracks={currentTimelineData}
											now={new Date()}
											toggleTrackOpen={null}
											enableSticky
											scrollToNow
										/>
									</TimelineWrapper>
									<TimelineNextHandler
										className={'rt-timeline-handler'}
										heightHelper={heightTimeline}
										hovered={timelineHovered}
										widthHelper={widthTimeline}
										onMouseOver={() => setTimelineHovered(true)}
									>
										<TimelineArrowWrapper onClick={() => handleDataTimeline(moment(timelineEndYear).format('YYYY'))}>
											<TimelineArrowContentWrapper>
												<TimelineArrowNext />
												<span>{moment(timelineEndYear).format('YYYY')}</span>
											</TimelineArrowContentWrapper>
										</TimelineArrowWrapper>
									</TimelineNextHandler>
									<TimelineLegendWrapper widthHelper={widthTimeline}>
										{map(articleLifeManager.timelineLegend, (elem, _id) => (
											<TimelineLegendPart>
												<TimelineLegendColorCode colorCode={elem.coloCode} />
												<TimelineLegend>{translations[elem.translationKey]}</TimelineLegend>
											</TimelineLegendPart>
										))}
									</TimelineLegendWrapper>
								</Fragment>
							)}
					</TimelineHandler>
					<div></div>
				</PageWrapperGridsCustom>
			</ArticleLifeManagerWrapper>
		</Fragment>
	)
}

ArticleLifeManager.propTypes = {}

ArticleLifeManager.defaultPropTypes = {}

export default ArticleLifeManager
